export const PXS_SECURE_NET_FIX = 'Proximus Secure Net Fix';
export const PXS_SECURE_NET_MOBILE = 'Proximus Secure Net Mobile';
export const NORTON_SEC_5 = 'Norton Security 5';
export const EASY_PROTECT = 'Easy Protect';
export const EASY_PROTECT_NAME = 'easy-protect';
export const NORTON_PRODUCT = 'NORTON';
